<template>
  <div class="counter">
    <div class="container">
      <h1>Количество участников опроса</h1>
      <div class="counter-numbers">
        <span class="counter-number" v-for="(count, i) in counter" :key="i">
          <span v-if="!count">{{0}}</span>
          <span v-else>{{count}}</span>
        </span>
      </div>
      <span class="counter-text">*на основе данных пользователей, принявших участие в опросе на <span class="counter-text__blue">epidemic.hculture.ru</span></span>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    await this.$store.dispatch('getUsers');
    const string = this.$store.state.users + "";
    let array = Array.from(string);
    array.fill(0, -3, 0);
    let counter = [...new Array(7 - array.length)];
    for (let i = 0; i < array.length; i++) {
      counter.push(array[i]);
    }
    this.counter = counter;
  },
  data() {
    return {
      counter: [0, 0, 0, 0, 0, 0, 0]
    }
  },
}
</script>

<style lang="scss" scoped>
.counter {
  background-color: #f2f7f9;
  padding-bottom: 60px;
  &-numbers {
    text-align: center;
    margin-bottom: 30px;
  }
  &-number {
    width: 81px;
    height: 110px;
    box-shadow: 0 3px 6px rgba(194, 213, 225, 0.99);
    border-radius: 3px;
    background-color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 4px;
    font-size: 90px;
    color: #0096c8;
    font-weight: bold;
  }
  &-text {
    display: block;
    text-align: center;
    &__blue {
      color: #0096c8;
      font-weight: bold;
    }
  }
}

@media screen and (max-width: 767px) {
  .counter {
    padding: 46px 0;
    &-nubmers {
      margin-bottom: 20px;
    }
    &-number {
      width: 36px;
      height: 49px;
      font-size: 35px;
      margin: 0 2px;
    }
    .container {
      padding: 0 15px;
    }
    &-text {
      font-size: 12px;
    }
  }
}
</style>